import { type Column, type Row } from '../components/Table'

export const getColumnValuesToFilter = (checkboxValues: Record<string, boolean>) => {
  return Object.entries(checkboxValues)
    .filter(([_, value]) => value)
    .map(([key]) => key)
}

export function extractRowsFromColumn (field: string, columns: Column[], rows: Row[]) {
  const fieldExists = columns.some((column) => column.field === field)

  if (!fieldExists) {
    console.error('Column to extract does not exist')
    return []
  }

  return rows.map((row) => {
    const values = Object.entries(row)
      .filter(([key]) => key === field)
      .map(([_, value]) => value)
    return values
  })
}
